<template>
    <div>
      <!-- Alert: No item found -->
      <b-alert
        variant="danger"
        :show="!userData"
      >
        <h4 class="alert-heading">
          Aucun utilisateur n'est connecté
        </h4>
        <div class="alert-body">
          Retourner sur la page de
          <b-link
            class="alert-link"
            :to="{ name: 'login' }"
          >
            Connexion
          </b-link>.
        </div>
      </b-alert>

      <template v-if="userData">

        <b-row class="match-height">
          <b-col
            cols="12"
            md="7"
            lg="10"
            xl="10"
          >
            <user-view-user-info-card :user-data="userData" />
          </b-col>
          <b-col
            cols="12"
            md="5"
            lg="2"
            xl="2"
          >
            <user-hierachic-view :user-data="userData" />
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <status :user-data="userData" />
          </b-col>
        </b-row>

        <b-row class="match-height">
        <b-col
          cols="12"
          lg="6"
        >
          <objectif-view-user-timeline-card :user-data="userData"/>
        </b-col>
        <b-col
          cols="12"
          lg="6"
        >
          <evaluation-view-user-timeline-card :user-data="userData"/>
        </b-col>
      </b-row>
      </template>
    </div>
  </template>

  <script>
  import { ref } from '@vue/composition-api'
  import {
    BRow, BCol, BAlert, BLink,
  } from 'bootstrap-vue'
  import UserViewUserInfoCard from './UserViewUserInfoCard.vue'
  import UserHierachicView from './UserHierachicView.vue'
  import ObjectifViewUserTimelineCard from './ObjectifViewUserTimelineCard.vue'
  import EvaluationViewUserTimelineCard from './EvaluationViewUserTimelineCard.vue'

  import { isUserLoggedIn } from '@/auth/utils';
  import { getJsonFromStorage } from "@/util/storageUtils";
  import EvaluationDateScheduler from "@/views/profil/EvaluationDateScheduler.vue";
  import Status from "@/views/profil/Status.vue";

  export default {
    components: {
      Status,
      BRow,
      BCol,
      BAlert,
      BLink,
      UserViewUserInfoCard,
      UserHierachicView,
      ObjectifViewUserTimelineCard,
      EvaluationViewUserTimelineCard
    },
    setup() {
      const userData = ref(null);
      return {
        userData,
      };
    },
    created() {
      if (isUserLoggedIn()) {
        const storedUserData = getJsonFromStorage('userData');
        if (storedUserData) {
          this.userData =storedUserData;
        }
      } else {
        this.$router.push({ name: 'login' });
      }
    }
  }
  </script>
